import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { createEpicMiddleware } from 'redux-observable';
import { composeWithDevTools } from 'redux-devtools-extension';
import combinedReducer from './../reducers/index';
import combinedEpic from './../epics';
import { Map } from 'immutable';
import { logout } from '../actions/Authentication';
import { dfimAxios } from './Axios';

const epicMiddleware = createEpicMiddleware();

/**
 * Creates axios middleware and configure interceptor response.
 * @param dfimAxios
 * @returns {function({dispatch: *, getState: *}): function(*): function(*=): *}
 */
const createAxiosMiddleware =
  (dfimAxios) =>
  ({ dispatch, getState }) => {
    dfimAxios.interceptors.response.use(null, (error) => {
      if (error.response.status === 401) {
        console.log('Received HTTP 401 (Unauthorized). Attempting to logout...');
        dispatch(logout());
      }
      return Promise.reject(error);
    });

    return (next) => (action) => next(action);
  };

const axiosMiddleware = createAxiosMiddleware(dfimAxios);

/**
 * Configures the redux store:
 * - Combining all reducers.
 * - Combining all Epics as middleware.
 * - Applies middleware
 * - Enhances with Redux Dev Tool
 * - Creates store.
 * */
export const configureStore = () => {
  const initialState = Map();

  const middleware = applyMiddleware(epicMiddleware, axiosMiddleware, routerMiddleware());

  const store = createStore(combinedReducer, initialState, composeWithDevTools(middleware));
  epicMiddleware.run(combinedEpic);

  return store;
};
